import React, { Fragment, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { login } from "../../actions/security";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setState((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    dispatch(login(state, navigate));
  };

  return (
    <Fragment>
      <Header nameClass={"backgorund-color-header"} />
      <div className="login-page-holder">
        <div className="login-page-image">
          <div className="login-page-image-title">
            <h1>{t("login.info2")}</h1>
            <h1>{t("login.info3")}</h1>
          </div>
        </div>
        <div className="login-content-form">
          <h2>{t("login.info")}</h2>
          <form onSubmit={onSubmitHandler}>
            <Row>
              <Col lg={12} className="mb-3">
                <TextField
                  type="email"
                  label={t("login.email")}
                  name="email"
                  variant="standard"
                  value={state.email}
                  onChange={onChangeHandler}
                  className="w-100"
                />
              </Col>
              <Col lg={12}>
                <TextField
                  type={showPassword ? "text" : "password"}
                  name="password"
                  label={t("login.password")}
                  variant="standard"
                  value={state.password}
                  onChange={onChangeHandler}
                  className="w-100"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Col>
              <Col className="login-button-item">
                <Button type="submit">{t("login.prijava")}</Button>
              </Col>
            </Row>
          </form>
          <div className="registration-section-login-page d-flex justify-content-between align-items-center">
            <div className="registration-button">
              <Link to="/registration">{t("login.registruj_se")}</Link>
            </div>
            <div className="forgot-passwrod">
              <Link to="/forgot-password">{t("login.forgot_password")}</Link>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
